import React from 'react'
import { Link } from 'gatsby'

import { Layout, Header, SectionTitle, Intro } from '../../../../components'

import data from './data.json'

import './style.scss'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        category="Overview"
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        complete={true}
      >
        <Intro>
          <p>
            Typography guides a user through an experience by creating hierarchy
            and organizing information within the design. Refer to the{' '}
            <Link
              className="link"
              to={'/' + data.site + '/components/title/develop'}
            >
              title
            </Link>
            ,{' '}
            <Link
              className="link"
              to={'/' + data.site + '/components/title/develop'}
            >
              text content
            </Link>{' '}
            and relevant components for proper usage.
          </p>
          <p>
            M&amp;T Bank uses <strong>M&amp;T Balto</strong> as the primary
            typeface for its visual language. The font was designed specifically
            for M&amp;T by Tal Leming of Type Supply.
          </p>
        </Intro>
        <SectionTitle>Font Family</SectionTitle>
        <div class="fonts">
          <div class="default-font">
            <div class="font-preview">M&amp;T Balto</div>
            <div class="font-caption">Default Font</div>
          </div>
          <div class="other-fonts__container">
            <div class="other-fonts">
              <div class="font-preview u-type--weight-300">Aa</div>
              <div class="font-caption">
                <strong>SemiLight</strong> 200
              </div>
            </div>
            <div class="other-fonts">
              <div class="font-preview u-type--weight-400">Aa</div>
              <div class="font-caption">
                <strong>Book</strong> 300
              </div>
            </div>
            <div class="other-fonts">
              <div class="font-preview">Aa</div>
              <div class="font-caption">
                <strong>Medium</strong> 500
              </div>
            </div>
          </div>
        </div>
        <table class="table">
          <thead>
            <th>Style</th>
            <th>Weight</th>
            <th>Font Values</th>
            <th>Color</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="typography__title-1">Title1</div>
              </td>
              <td> SemiLight </td>
              <td>
                <div class="typography__font-values">
                  Font-size: <span class="value">32px</span> <br /> Line-height:
                  <span class="value">40px</span>
                </div>
              </td>
              <td> #007856, #FFF </td>
            </tr>
            <tr>
              <td>
                <div class="typography__title-2">Title2</div>
              </td>
              <td>SemiLight </td>
              <td>
                <div class="typography__font-values">
                  Font-size: <span class="value">24px</span> <br /> Line-height:
                  <span class="value">40px</span>
                </div>
              </td>
              <td> #333, #FFF </td>
            </tr>
            <tr>
              <td>
                <div class="typography__title-3">Title3</div>
              </td>
              <td>Medium </td>
              <td>
                <div class="typography__font-values">
                  Font-size: <span class="value">16px</span> <br /> Line-height:
                  <span class="value">24px</span>
                </div>
              </td>
              <td> #333, #FFF </td>
            </tr>
            <tr>
              <td>
                <div class="typography__title-4">Title4</div>
              </td>
              <td>SemiLight </td>
              <td>
                <div class="typography__font-values">
                  Font-size: <span class="value">12px</span> <br /> Line-height:
                  <span class="value">18px</span> <br /> Letter-spacing:
                  <span class="value">2px</span>
                </div>
              </td>
              <td> #333, #D7D7D7, #FFF </td>
            </tr>
            <tr>
              <td>
                <div class="c-text-content-lead--normal">LeadParagraph</div>
              </td>
              <td>SemiLight </td>
              <td>
                <div class="typography__font-values">
                  Font-size: <span class="value">20px</span> <br /> Line-height:
                  <span class="value">30px</span>
                </div>
              </td>
              <td> #333, #FFF </td>
            </tr>
            <tr>
              <td>
                <div class="c-text-content-body--normal">Body</div>
              </td>
              <td> Book </td>
              <td>
                <div class="typography__font-values">
                  Font-size: <span class="value">16px</span> <br /> Line-height:
                  <span class="value">24px</span>
                </div>
              </td>
              <td> #333, #FFF </td>
            </tr>
            <tr>
              <td>
                <div class="c-text-content-caption--normal">Caption</div>
              </td>
              <td>Book</td>
              <td>
                <div class="typography__font-values">
                  Font-size: <span class="value">12px</span> <br /> Line-height:
                  <span class="value">18px</span>
                </div>
              </td>
              <td> #333, #D7D7D7, #FFF </td>
            </tr>
          </tbody>
        </table>
      </Layout>
    </>
  )
}
